export default __webpack_public_path__ + "static/color-wheel-f64667c579051140e477e79f3c31ff88.png";